import globalConstant from 'constants/globalConstant';
import { getURLParameter } from '.';

const isWrouteValue = (paramName) => {
	return (
		getURLParameter(globalConstant.URL_PARAMETER.WROUTE) &&
		getURLParameter(globalConstant.URL_PARAMETER.WROUTE) === paramName
	);
};

export default isWrouteValue;
